export default __webpack_public_path__ + "static/media/section1-bg1.1020c44d.png";